import { memo, useCallback, useState } from "react";
import loadable from "@loadable/component";
import Button, { BUTTON_VARIANTS } from "app/pages/.shared/form/Button";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

import Modal from "app/pages/.shared/Modal/Modal.jsx";

// chargé à l'ouverture de la modale : évite d'embarquer react-phone-number-input/max au démarrage
const ClickToCallContainer = loadable(() =>
	import(/* webpackChunkName: "click-to-call" */ "./ClickToCallContainer.jsx")
);

import "./ClickToCallCta.scss";
import { CallFilledIcon } from "app/icons/profile";

const ClickToCallCta = ({ officeHours = [] }) => {
	const [modalOpened, setModalOpen] = useState(false);

	const handleOpenModal = useCallback(() => {
		setModalOpen(true);
	}, []);

	const handleCloseModal = useCallback(() => {
		setModalOpen(false);
	}, []);

	return (
		<div className="click-to-call-cta">
			<div className="click-to-call-cta__container">
				<div className="click-to-call-cta__schedules">
					{officeHours.length > 0 ? (
						officeHours[0]
					) : (
						<FormattedMessage id="click.to.call.cta.schedules" />
					)}
				</div>
				<Button
					variant={BUTTON_VARIANTS.STROKE}
					onClick={handleOpenModal}
					loading={false}
					className="click-to-call-cta__button"
					data-testid="click-to-call-button"
					icon={<CallFilledIcon />}
					label={<FormattedMessage id="click.to.call.cta.value" />}
				/>
				<Modal
					opened={modalOpened}
					handleClose={handleCloseModal}
					title={<FormattedMessage id="click.to.call.cta.value" />}
				>
					<ClickToCallContainer handleClose={handleCloseModal} />
				</Modal>
			</div>
		</div>
	);
};

ClickToCallCta.propTypes = {
	officeHours: PropTypes.array,
};

export default memo(ClickToCallCta);
